"use client";

import posthog from "posthog-js";
import { useEffect } from "react";
import { DefaultErrorPage } from "@/components/default-error-page";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    posthog.captureException(error, {
      digest: error.digest,
    });
  }, [error]);

  return <DefaultErrorPage error={error} reset={reset} />;
}
